import styled from 'styled-components';

import { applyElevation, themeGet } from '@packages/ui';

export type ArrowProps = {
  className?: string;
  onClick?: (event: MouseEvent) => void;
};

export const Arrow = styled.button`
  ${applyElevation};
  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.9);
  height: 60px;
  width: 28px;
  border: none;
  padding: 0;
  transition: color 200ms linear;
  &:focus {
    outline: none;
  }
  color: ${themeGet.colors('sandDune')};

  &:hover {
    color: ${themeGet.colors('secondary')};
  }
`;
